import { Sparkle } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { TOKEN } from '@/lib/brandColors';

// Ruta AI's signature "forest-glass" look, defined once so every assistant
// surface (popover, header trigger, future entry points) stays identical.
export const ASSISTANT_BRAND = {
  glow: (alpha: number) => `rgba(134,184,134,${alpha})`,
  sage: '#86b886',
  panelBg: 'rgba(10,26,10,0.92)',
  panelBorder: 'rgba(134,184,134,0.25)',
  gradient: `linear-gradient(135deg, ${TOKEN.primary}, ${TOKEN.primaryHover})`,
} as const;

// The bare Ruta AI sparkle glyph in sage — the mobile-style mark, sits inline
// to the left of the "Ruta AI" title.
export function AssistantGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <Sparkle
      style={{ width: size, height: size, color: ASSISTANT_BRAND.sage }}
      className={cn('shrink-0', className)}
    />
  );
}

// The Ruta AI logo: a Sparkle inside a forest-gradient tile (glyph = half the edge).
export function AssistantMark({
  size = 28,
  glow = true,
  className,
}: {
  size?: number;
  glow?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn('flex items-center justify-center rounded-lg shrink-0', className)}
      style={{
        width: size,
        height: size,
        background: ASSISTANT_BRAND.gradient,
        boxShadow: glow ? `0 0 12px ${ASSISTANT_BRAND.glow(0.5)}` : undefined,
      }}
    >
      <Sparkle style={{ width: size * 0.5, height: size * 0.5 }} className="text-white" />
    </div>
  );
}
